export enum AgencyName {
  DA_TRAVEL = 'da-travel',
  STUDENTSKI_POHODI = 'studentski-pohodi',
  VICTORIUS_TRAVEL = 'victorius-travel',
  VENTURA_TRAVEL = 'ventura-travel',
  TRAVEL_CENTRAL = 'travel-centar',
  RELAX_TOURS = 'relax-tours',
  AVIO_EXPRESS = 'avio-express',
  VAS_TOUR_BOSNIA = 'vas-tour-bosnia',
  ME_TRAVEL = 'me-travel',
  RIJASET = 'rijaset',
  MONDARO = 'mondaro',
  //   CENTROTOURS = 'centrotours',
}

export const US_PROMO_COLLECTION = '6a12e003e7c26fc4d6698d17'

export const US_PROMO_PACKAGES = [
  // '6a12e1a167323f36a18d7479', // canada 3 gb 7 days
  // '6a2475e582819be14c271dc3', // canada 5 gb 30 days
  // '6a12e1a1a7f3dcafc6f6596e', // usa 5 gb 7 days
  // '6a12e19ea1b832345b1bd979', // usa 10 gb 14 days
  // '6a12e19ee7c26fc4d6698d3a', // usa 10 gb 30 days
]

export const PROMO_PACKAGES = [
  '6a3e3bf5b7435b2be2c48e8c', // DA Travel 3 gb 10 days
  '6a79b9c1c5a410918157640d', // Avio Express 3 gb 10 days
  '68a4ce860558a5fe4f6481f3', // Ventura Travel 5 gb
  '6a847d424e087477eee5edc6', // Studentski pohodi 5 gb
]

export const MATURANTI_MOSTAR_COLLECTION = '6a9dd90f9dc6f56c881eab26'
export const EKSKURZIJA_SPANIJA_ITALIJA_2026_COLLECTION = '6aa3c823403e39c8accf9eb1'

export interface Agency {
  id: string
  name: AgencyName
  title: string
  logo: {
    url: string
    alt: string
    width: number
    height: number
  }
  description: {
    bs: string
    en: string
  }
  image: {
    bs: string
    en: string
  }
  /** Email header image used for order notification emails */
  header_image_url?: string
}

export interface PartnerCollection {
  id?: string
  code: string
  name: string
  en: string
  bs: string
  countries: number
  priceUSD: number // 1 GB = X USD
  priceBAM: number // 1 GB = X BAM
  priceEUR: number // 1 GB = X EUR
}

export const agencies: Agency[] = [
  {
    id: 'da-travel-7k2m9p',
    name: AgencyName.DA_TRAVEL,
    title: 'DA Travel',
    logo: {
      url: '',
      alt: 'DA Travel',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa DA Travel agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with DA Travel agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/da-travel.png',
      en: '/agency/da-travel.png',
    },
    header_image_url: 'https://esimfly-public.s3.eu-central-1.amazonaws.com/email/email-header-sm-da-travel.png',
  },
  {
    id: 'studentski-pohodi-k8n2p4',
    name: AgencyName.STUDENTSKI_POHODI,
    title: 'Studentski pohodi',
    logo: {
      url: '',
      alt: 'Studentski pohodi',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Studentskim pohodima, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Studentski pohodi, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/studentski-pohodi.png',
      en: '/agency/studentski-pohodi.png',
    },
    header_image_url: 'https://esimfly-public.s3.eu-central-1.amazonaws.com/email/email-header-sm-studentski-pohodi.png',
  },
  {
    id: 'rijaset-51rt5t',
    name: AgencyName.RIJASET,
    title: 'Rijaset',
    logo: {
      url: ``,
      alt: 'Rijaset',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Rijaset agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Rijaset agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/rijaset.png',
      en: '/agency/rijaset.png',
    },
    header_image_url: 'https://esimfly-public.s3.eu-central-1.amazonaws.com/email/email-header-with-logo-rijaset-2.png',
  },
  {
    id: 'mondaro-m7s4t2',
    name: AgencyName.MONDARO,
    title: 'Mondaro',
    logo: {
      url: '',
      alt: 'Mondaro',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'eSIM paketi za Mondaro ekskurzije — preuzmite sada, platite vodiču na dan polaska.',
      en: 'eSIM packages for Mondaro excursions — install now, pay the guide on departure day.',
    },
    image: {
      bs: '/blog/mondaro-maturanti-ekskurzija-spanija.jpg',
      en: '/blog/mondaro-maturanti-ekskurzija-spanija.jpg',
    },
    header_image_url: 'https://www.esimfly.app/blog/mondaro-maturanti-ekskurzija-spanija.jpg',
  },
  {
    id: 'victorius-travel-p4f1a2',
    name: AgencyName.VICTORIUS_TRAVEL,
    title: 'Victorius Travel',
    logo: {
      url: `https://victorius.ba/storage/2024/08/victorius-travel-logo-horizontal.svg`,
      alt: 'Victorius Travel',
      width: 220,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Victorius Travel agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i  Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Victorius Travel agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/victorius-travel.png',
      en: '/agency/victorius-travel.png',
    },
  },
  {
    id: 'ventura-travel-x3u8a1',
    name: AgencyName.VENTURA_TRAVEL,
    title: 'Ventura Travel',
    logo: {
      url: `https://ventura.travel/assets/images/ventura_logo_full.png`,
      alt: 'Ventura Travel',
      width: 100,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Ventura Travel agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i  Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Ventura Travel agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/ventura-travel.png',
      en: '/agency/ventura-travel.png',
    },
    header_image_url: 'https://esimfly-public.s3.eu-central-1.amazonaws.com/email/email-header-sm-ventura-travel.png',
  },
  {
    id: 'travel-centar-5323s',
    name: AgencyName.TRAVEL_CENTRAL,
    title: 'Travel Centar',
    logo: {
      url: `https://travelcentar.ba/images/logo.png`,
      alt: 'Travel Centar',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Travel Centar agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Travel Centar agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/travel-centar.png',
      en: '/agency/travel-centar.png',
    },
    header_image_url: 'https://esimfly-public.s3.eu-central-1.amazonaws.com/email/email-header-sm-travel-centar.png',
  },
  {
    id: 'vas-tour-bosnia-51rt5t',
    name: AgencyName.VAS_TOUR_BOSNIA,
    title: 'VAS Tour Bosnia',
    logo: {
      url: `https://tr2storage.blob.core.windows.net/agencylogos/NPOocG9bhH1VNfyFSc-jeesbzHAOi3tf4z.png`,
      alt: 'VAS Tour Bosnia',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa VAS Tour Bosnia agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with VAS Tour Bosnia agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/vas-tour-bosnia.png',
      en: '/agency/vas-tour-bosnia.png',
    },
  },
  {
    id: 'relax-tours-f4g5f4',
    name: AgencyName.RELAX_TOURS,
    title: 'Relax Tours',
    logo: {
      // url: `https://relaxtours.com/wp-content/uploads/2022/03/cropped-cropped-logo-final1.png`, // dark
      url: `https://relaxtours.com/wp-content/uploads/2022/04/relax-white.png`, // white
      alt: 'Relax Tours',
      width: 150,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Relax Tours agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Relax Tours agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/relax-tours.png',
      en: '/agency/relax-tours.png',
    },
  },
  {
    id: 'avio-express-b3a2b3',
    name: AgencyName.AVIO_EXPRESS,
    title: 'Avio Express',
    logo: {
      url: `https://avioexpress.ba/wp-content/uploads/2022/04/avio-768x209.png`,
      alt: 'Avio Express',
      width: 300,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa Avio Express agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with Avio Express agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/avio-express.png',
      en: '/agency/avio-express.png',
    },
    header_image_url: 'https://esimfly-public.s3.eu-central-1.amazonaws.com/email/email-header-sm-avio-express.png',
  },
  {
    id: 'me-travel-b6c7b6',
    name: AgencyName.ME_TRAVEL,
    title: 'Me Travel',
    logo: {
      url: `www.esimfly.app/me-travel.png`,
      alt: 'Me Travel',
      width: 300,
      height: 100,
    },
    description: {
      bs: 'Sa zadovoljstvom objavljujemo saradnju sa MeTravel agencijom, kroz koju vam donosimo povoljnije cijene za eSIM pakete i Travel SIM kartice',
      en: 'We are pleased to announce our collaboration with MeTravel agency, through which we bring you better prices for eSIM packages and Travel SIM cards',
    },
    image: {
      bs: '/agency/me-travel.png',
      en: '/agency/me-travel.png',
    },
  },
]

const _victoriusTravel: PartnerCollection[] = [
  {
    code: 'es',
    id: '690628d0bcdd62c11ea75fc3',
    name: '',
    en: 'Spain',
    bs: 'Španija',
    countries: 1,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'tr',
    id: '68e028ff6d48b6c68f6008f3',
    name: '',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.1, // 1 GB = 2.1 USD
    priceBAM: 3.6, // 1 GB = 3.6 BAM
    priceEUR: 1.9, // 1 GB = 1.9 EUR
  },
  {
    code: 'pt',
    id: '68be93451087a639b5789844',
    name: '',
    en: 'Portugal',
    bs: 'Portugal',
    countries: 1,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'jp',
    id: '691a15a057ba294cbc53ab53',
    name: '',
    en: 'Japan',
    bs: 'Japan',
    countries: 1,
    priceUSD: 2.7, // 1 GB = 2.7 USD
    priceBAM: 4.2, // 1 GB = 4.2 BAM
    priceEUR: 2.1, // 1 GB = 2.1 EUR
  },

  // {
  //   code: 'id',
  //   id: '689e2a65b3c109d10d3ff5ff',
  //   name: '',
  //   en: 'Indonesia',
  //   bs: 'Indonezija',
  //   countries: 1,
  //   priceUSD: 2.9, // 1 GB = 2.9 USD
  //   priceBAM: 4.6, // 1 GB = 4.6 BAM
  //   priceEUR: 2.4, // 1 GB = 2.4 EUR
  // },
  // {
  //   code: 'ma',
  //   id: '68dbe3a72932d37f80528b28',
  //   name: '',
  //   en: 'Morocco',
  //   bs: 'Maroko',
  //   countries: 1,
  //   priceUSD: 3.8, // 1 GB = 2.9 USD
  //   priceBAM: 6.5, // 1 GB = 4.6 BAM
  //   priceEUR: 3.3, // 1 GB = 3.5 EUR
  // },
]

const _relaxTours = [
  {
    code: 'Europe',
    id: '68c422219d95d37268afb189',
    name: '',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'es',
    id: '68c4287adbaedb07fc04e414',
    name: '',
    en: 'Spain',
    bs: 'Španija',
    countries: 1,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'tr',
    id: '68c42837dbaedb07fc04e407',
    name: '',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.1, // 1 GB = 2.1 USD
    priceBAM: 3.6, // 1 GB = 3.6 BAM
    priceEUR: 1.9, // 1 GB = 1.9 EUR
  },
  {
    id: '68c42914dbaedb07fc04e420',
    code: 'eg',
    name: '',
    en: 'Egypt',
    bs: 'Egipat',
    countries: 1,
    priceUSD: 4, // 1 GB = 4 USD
    priceBAM: 6.7, // 1 GB = 6.7 BAM
    priceEUR: 3.5, // 1 GB = 3.5 EUR
  },
  {
    code: 'tn',
    id: '68c4297bdbaedb07fc04e432',
    name: '',
    en: 'Tunis',
    bs: 'Tunis',
    countries: 1,
    priceUSD: 4, // 1 GB = 4 USD
    priceBAM: 6.7, // 1 GB = 6.7 BAM
    priceEUR: 3.5, // 1 GB = 3.5 EUR
  },
]

const _venturaTravel: PartnerCollection[] = [
  {
    code: 'Europe',
    id: '68a38c95539b27a791acece0',
    name: '',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'es',
    name: '',
    id: '68de2b860ec178d84d703ef9',
    en: 'Spain',
    bs: 'Španija',
    countries: 1,
    priceUSD: 2.7, // 1 GB = 2.7 USD
    priceBAM: 4.5, // 1 GB = 4.6 BAM
    priceEUR: 2.3, // 1 GB = 2.4 EUR
  },
  {
    code: 'tr',
    name: '',
    id: '68a4ce860558a5fe4f6481e7',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.4, // 1 GB = 2.1 USD
    priceBAM: 3.9, // 1 GB = 3.9 BAM
    priceEUR: 2.0, // 1 GB = 1.9 EUR
  },
  {
    code: 'tn',
    name: '',
    id: '68a31a5bde22612bc94cb59e',
    en: 'Tunis',
    bs: 'Tunis',
    countries: 1,
    priceUSD: 2.7, // 1 GB = 2.7 USD
    priceBAM: 4.5, // 1 GB = 4.6 BAM
    priceEUR: 2.3, // 1 GB = 2.4 EUR
  },
  {
    code: 'mt',
    name: '',
    id: '68a4d7cf869269ebe5d9a63c',
    en: 'Malta',
    bs: 'Malta',
    countries: 1,
    priceUSD: 2.7, // 1 GB = 2.7 USD
    priceBAM: 4.4, // 1 GB = 4.4 BAM
    priceEUR: 2.3, // 1 GB = 2.3 EUR
  },
  {
    name: '',
    code: 'ae',
    id: '695f8a87520b9319e418d936',
    en: 'United Arab Emirates',
    bs: 'Ujedinjeni Arapski Emirati',
    countries: 1,
    priceUSD: 3.7, // 1 GB = 2.9 USD
    priceBAM: 5.7, // 1 GB = 5.9 BAM
    priceEUR: 3.0, // 1 GB = 1.9 EUR
  },
  {
    code: 'ma',
    id: '68dbe3ab2932d37f80528b33',
    name: '',
    en: 'Morocco',
    bs: 'Maroko',
    countries: 1,
    priceUSD: 3.8, // 1 GB = 2.9 USD
    priceBAM: 6.5, // 1 GB = 4.6 BAM
    priceEUR: 3.3, // 1 GB = 3.5 EUR
  },
  {
    code: 'jp',
    id: '68e9295938d2f2cad4e195ba',
    name: '',
    en: 'Japan',
    bs: 'Japan',
    countries: 1,
    priceUSD: 2.3, // 1 GB = 2.9 USD
    priceBAM: 4.2, // 1 GB = 4.6 BAM
    priceEUR: 2.3, // 1 GB = 3.5 EUR
  },
]

const _travelCentral: PartnerCollection[] = [
  {
    code: 'Europe',
    name: '',
    id: '68bec7d49995ca9d7182cf94',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'tr',
    name: '',
    id: '68bec78162ed6778227d0682',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.4, // 1 GB = 2.1 USD
    priceBAM: 3.9, // 1 GB = 3.9 BAM
    priceEUR: 2.0, // 1 GB = 1.9 EUR
  },
]

const _vasTourBosnia: PartnerCollection[] = [
  {
    code: 'Europe',
    name: '',
    id: '68d99bd469db78c46e3592b9',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'tr',
    name: '',
    id: '68d99c2a69db78c46e3592d7',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.4, // 1 GB = 2.1 USD
    priceBAM: 3.9, // 1 GB = 3.9 BAM
    priceEUR: 2.0, // 1 GB = 1.9 EUR
  },
  {
    code: 'ae',
    name: '',
    id: '68d99d9552709e38e5324036',
    en: 'United Arab Emirates',
    bs: 'Ujedinjeni Arapski Emirati',
    countries: 1,
    priceUSD: 3.6, // 1 GB = 2.9 USD
    priceBAM: 5.9, // 1 GB = 5.9 BAM
    priceEUR: 3.1, // 1 GB = 1.9 EUR
  },
]

const _centrotours: PartnerCollection[] = [
  {
    code: 'Europe',
    name: '',
    id: '68bec7d49995ca9d7182cf94',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },
  {
    code: 'tr',
    name: '',
    id: '68bec78162ed6778227d0682',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.4, // 1 GB = 2.1 USD
    priceBAM: 3.9, // 1 GB = 3.9 BAM
    priceEUR: 2.0, // 1 GB = 1.9 EUR
  },
]

const _avioExpress: PartnerCollection[] = [
  {
    code: 'sa',
    id: '690860065d9d4e2d628dc51d',
    name: '',
    en: 'Saudi Arabia',
    bs: 'Saudijska Arabija',
    countries: 1,
    priceUSD: 5.8, // 2 GB = 2.9 USD
    priceBAM: 9.9, // 2 GB = 9.9 BAM
    priceEUR: 4.9, // 2 GB = 4.9 EUR
  },
  {
    code: 'Europe',
    id: '68c8321fe600f96d1648a553',
    name: '',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },

  {
    code: 'tr',
    id: '68c83201e600f96d1648a53a',
    name: '',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.1, // 1 GB = 2.1 USD
    priceBAM: 3.6, // 1 GB = 3.6 BAM
    priceEUR: 1.9, // 1 GB = 1.9 EUR
  },
  {
    id: '68c831e7e600f96d1648a520',
    code: 'eg',
    name: '',
    en: 'Egypt',
    bs: 'Egipat',
    countries: 1,
    priceUSD: 4, // 1 GB = 4 USD
    priceBAM: 6.7, // 1 GB = 6.7 BAM
    priceEUR: 3.5, // 1 GB = 3.5 EUR
  },
  {
    code: 'tn',
    id: '68c831be5b8350e9b9c0ec8f',
    name: '',
    en: 'Tunis',
    bs: 'Tunis',
    countries: 1,
    priceUSD: 4, // 1 GB = 4 USD
    priceBAM: 6.7, // 1 GB = 6.7 BAM
    priceEUR: 3.5, // 1 GB = 3.5 EUR
  },
]

const _meTravel: PartnerCollection[] = [
  {
    code: 'tr',
    name: '',
    id: '69356d9cd37394e3aa6b781f',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.1, // 1 GB = 2.1 USD
    priceBAM: 3.6, // 1 GB = 3.6 BAM
    priceEUR: 1.9, // 1 GB = 1.9 EUR
  },
  {
    code: 'Europe',
    name: '',
    id: '69356de6052c94b79918960c',
    en: 'Europe',
    bs: 'Europa',
    countries: 40,
    priceUSD: 2.9, // 1 GB = 2.9 USD
    priceBAM: 4.6, // 1 GB = 4.6 BAM
    priceEUR: 2.4, // 1 GB = 2.4 EUR
  },

  // {
  //   code: 'sa',
  //   id: '691a260a42b11bccd831974b',
  //   name: '',
  //   en: 'Saudi Arabia',
  //   bs: 'Saudijska Arabija',
  //   countries: 1,
  //   priceUSD: 5.8, // 2 GB = 2.9 USD
  //   priceBAM: 9.9, // 2 GB = 9.9 BAM
  //   priceEUR: 4.9, // 2 GB = 4.9 EUR
  // },
]

const _rijaset: PartnerCollection[] = [
  {
    code: 'sa',
    id: '69dc217d0a16c8a0d72b80f1',
    name: '',
    en: 'Saudi Arabia',
    bs: 'Saudijska Arabija',
    countries: 1,
    priceUSD: 5.8, // 2 GB = 2.9 USD
    priceBAM: 9.9, // 2 GB = 9.9 BAM
    priceEUR: 4.5, // 2 GB = 4.5 EUR
  },
  {
    code: 'sa',
    id: '6a7d78c3dfafda679a2b66be', // hadz 2027 popust
    name: '',
    en: 'Saudi Arabia',
    bs: 'Saudijska Arabija',
    countries: 1,
    priceUSD: 5.8, // 2 GB = 2.9 USD
    priceBAM: 9.9, // 2 GB = 9.9 BAM
    priceEUR: 4.5, // 2 GB = 4.5 EUR
  },
]

const _daTravel: PartnerCollection[] = [
  {
    code: 'tr',
    name: '',
    id: '6a3e3bcfb7435b2be2c48e7f',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.1, // 1 GB = 2.1 USD
    priceBAM: 3.6, // 1 GB = 3.6 BAM
    priceEUR: 1.9, // 1 GB = 1.9 EUR
  },
]

const _studentskiPohodi: PartnerCollection[] = [
  {
    code: 'tr',
    name: '',
    id: '6a5a5c8b9d5036cb2983ee0b',
    en: 'Turkiye',
    bs: 'Turska',
    countries: 1,
    priceUSD: 2.1, // 1 GB = 2.1 USD
    priceBAM: 3.6, // 1 GB = 3.6 BAM
    priceEUR: 1.9, // 1 GB = 1.9 EUR
  },
]

const _mondaro: PartnerCollection[] = [
  {
    code: 'Europe',
    name: '',
    id: MATURANTI_MOSTAR_COLLECTION,
    en: 'Europe',
    bs: 'Europa',
    countries: 5,
    priceUSD: 1.2,
    priceBAM: 2.0,
    priceEUR: 1.0,
  },
]

export const _partnerCollection: Record<AgencyName, PartnerCollection[]> = {
  // '': [
  //   {
  //     code: 'Europe',
  //     name: '',
  //     en: 'Europe',
  //     bs: 'Europa',
  //     countries: 40,
  //     priceUSD: 2.9, // 1 GB = 2.9 USD
  //     priceBAM: 4.6, // 1 GB = 4.6 BAM
  //     priceEUR: 2.4, // 1 GB = 2.4 EUR
  //   },
  //   {
  //     code: 'hr',
  //     name: '',
  //     en: 'Croatia',
  //     bs: 'Hrvatska',
  //     countries: 1,
  //     priceUSD: 2.9, // 1 GB = 2.9 USD
  //     priceBAM: 4.6, // 1 GB = 4.6 BAM
  //     priceEUR: 2.4, // 1 GB = 2.4 EUR
  //   },
  //   {
  //     code: 'tr',
  //     name: '',
  //     en: 'Turkiye',
  //     bs: 'Turska',
  //     countries: 1,
  //     priceUSD: 2.1, // 1 GB = 2.1 USD
  //     priceBAM: 3.6, // 1 GB = 3.6 BAM
  //     priceEUR: 1.9, // 1 GB = 1.9 EUR
  //   },
  //   {
  //     code: 'it',
  //     name: '',
  //     en: 'Italy',
  //     bs: 'Italija',
  //     countries: 1,
  //     priceUSD: 2.7, // 1 GB = 2.7 USD
  //     priceBAM: 4.5, // 1 GB = 4.6 BAM
  //     priceEUR: 2.3, // 1 GB = 2.4 EUR
  //   },
  //   {
  //     code: 'fr',
  //     name: '',
  //     en: 'France',
  //     bs: 'Francuska',
  //     countries: 1,
  //     priceUSD: 2.7, // 1 GB = 2.7 USD
  //     priceBAM: 4.5, // 1 GB = 4.6 BAM
  //     priceEUR: 2.3, // 1 GB = 2.4 EUR
  //   },
  //   {
  //     code: 'es',
  //     name: '',
  //     en: 'Spain',
  //     bs: 'Španija',
  //     countries: 1,
  //     priceUSD: 2.7, // 1 GB = 2.7 USD
  //     priceBAM: 4.5, // 1 GB = 4.6 BAM
  //     priceEUR: 2.3, // 1 GB = 2.4 EUR
  //   },
  // ],
  [AgencyName.VICTORIUS_TRAVEL]: _victoriusTravel,
  [AgencyName.VENTURA_TRAVEL]: _venturaTravel,
  [AgencyName.TRAVEL_CENTRAL]: _travelCentral,
  [AgencyName.RELAX_TOURS]: _relaxTours,
  [AgencyName.AVIO_EXPRESS]: _avioExpress,
  [AgencyName.VAS_TOUR_BOSNIA]: _vasTourBosnia,
  [AgencyName.ME_TRAVEL]: _meTravel,
  [AgencyName.RIJASET]: _rijaset,
  [AgencyName.DA_TRAVEL]: _daTravel,
  [AgencyName.STUDENTSKI_POHODI]: _studentskiPohodi,
  [AgencyName.MONDARO]: _mondaro,
}

export const resolveAgencyByCollection = (collectionId?: string | null): Agency | null => {
  if (!collectionId) {
    return null
  }

  const agencyNames = Object.keys(_partnerCollection)

  let agencyName = null
  for (const name of agencyNames) {
    const collections = _partnerCollection[name as AgencyName]
    for (const collection of collections) {
      if (collection.id === collectionId) {
        agencyName = name
        break
      }
    }
  }

  const agency = agencies.find(agency => agency.name === agencyName)
  return agency || null
}
